import {Controller} from '@hotwired/stimulus';
import $ from 'jquery';

/**
 * Allows you to dispatch a "modal:close" JavaScript event to close it.
 *
 * This is useful inside a LiveComponent, where you can emit a browser event
 * to open or close the modal.
 *
 * See templates/components/BootstrapModal.html.twig to see how this is
 * attached to Bootstrap modal.
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    bootstrapModal = null;

    connect() {
        this.bootstrapModal = $(this.element);
        document.addEventListener('modal:close', () => this.bootstrapModal.modal('hide'));
    }
}
